const milestones = [
  { year: '1982', title: 'University of Kentucky, M.D.', description: 'Completes medical degree at UK College of Medicine.' },
  { year: '1982–87', title: 'Yale–New Haven Hospital', description: 'Dual internship and orthopedic surgery residency at one of the nation\'s premier academic medical centers.' },
  { year: '1988', title: 'Fellowship — Cincinnati Sports Medicine', description: 'Specializes in sports reconstructive surgery and cartilage transplantation.' },
  { year: '2002', title: 'Top Doctors & Top Surgeons', description: 'First named to Cincinnati Magazine Top Doctors List and America\'s Top Surgeons—every year since.' },
  { year: '2004', title: 'Ohio Governor\'s Advisory Board', description: 'Appointed Chairman of the Ohio BWC Advisory Board, shaping workers\' compensation policy statewide.' },
  { year: '2010', title: 'Academy of Medicine Presidency', description: 'Serves as President of the Academy of Medicine of Greater Cincinnati and the Cincinnati Orthopaedic Society.' },
  { year: '2021', title: 'Joins Beacon Orthopaedics', description: 'Brings four decades of surgical excellence to Beacon Orthopaedics & Sports Medicine.' },
  { year: '2024', title: 'Launches LINK Revenue Integrity', description: 'Transforms a career of clinical insight into the platform that defines Procedure Revenue Integrity.', highlight: true },
];

export function TimelineOfIntegrity() {
  return (
    <section className="py-20 md:py-28 bg-background">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-14">
            <p className="text-xs font-semibold tracking-widest uppercase text-primary mb-4">
              Timeline of Integrity
            </p>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
              A Career in Service of Clinical Truth
            </h2>
          </div>

          <div className="relative">
            <div className="absolute left-[2.35rem] sm:left-[2.85rem] top-0 bottom-0 w-px bg-border" />

            <div className="space-y-1">
              {milestones.map((milestone) => (
                <div key={milestone.year + milestone.title} className="relative flex items-start gap-5 sm:gap-6">
                  <div className="flex-shrink-0 w-[4.7rem] sm:w-[5.7rem] text-right pt-5">
                    <span className={`text-xs sm:text-sm font-mono font-bold tracking-tight ${milestone.highlight ? 'text-primary' : 'text-muted-foreground'}`}>
                      {milestone.year}
                    </span>
                  </div>
                  <div className="relative flex-shrink-0 pt-5">
                    <div className={`w-3 h-3 rounded-full border-2 transition-colors ${milestone.highlight ? 'bg-primary border-primary' : 'bg-card border-border'}`} />
                  </div>
                  <div className={`flex-1 rounded-xl border p-5 mb-1 ${milestone.highlight ? 'border-primary/30 bg-primary/5' : 'border-border bg-card'}`}>
                    <h3 className={`text-sm font-bold tracking-tight mb-1 ${milestone.highlight ? 'text-primary' : 'text-foreground'}`}>
                      {milestone.title}
                    </h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {milestone.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
